import { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fechaHora } from "@/lib/constants";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "sonner";
import { ChevronLeft, Trash2 } from "lucide-react";

const ESTADO_LABEL = { pendiente: "Pendiente", autorizada: "Autorizada", rechazada: "Rechazada" };

export default function SolicitudesMuestraEliminadas() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/solicitudes-muestra-eliminadas").then((r) => setItems(r.data)).catch((e) => { toast.error(formatApiError(e.response?.data?.detail)); setItems([]); });
  }, []);

  if (user && !user.es_admin) return <Navigate to="/" replace />;

  return (
    <div className="p-6 lg:p-8 max-w-5xl" data-testid="solicitudes-eliminadas-page">
      <Link to="/solicitudes" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-800 mb-4 transition-colors">
        <ChevronLeft size={16} /> Solicitudes
      </Link>
      <div className="flex items-center gap-2 mb-6">
        <div className="h-9 w-9 rounded-xl bg-red-600 text-white flex items-center justify-center"><Trash2 size={18} /></div>
        <div>
          <h1 className="font-head text-3xl font-extrabold tracking-tight">Solicitudes de muestra eliminadas</h1>
          <p className="text-slate-500 mt-0.5">Registro de solicitudes eliminadas (soft delete). Solo visible para administradores.</p>
        </div>
      </div>

      {!items ? (
        <Skeleton className="h-64 rounded-xl" />
      ) : items.length === 0 ? (
        <Card className="p-12 text-center text-slate-400 border-dashed">No hay solicitudes eliminadas.</Card>
      ) : (
        <Card className="border-slate-200 shadow-sm overflow-hidden">
          <div className="overflow-x-auto thin-scroll">
            <table className="w-full text-sm min-w-[680px]">
              <thead>
                <tr className="border-b border-slate-200 bg-slate-50/80 text-left text-xs uppercase tracking-wide text-slate-500">
                  <th className="px-5 py-3 font-semibold">Folio</th>
                  <th className="px-4 py-3 font-semibold">Cliente</th>
                  <th className="px-4 py-3 font-semibold">Estatus</th>
                  <th className="px-4 py-3 font-semibold">Eliminada por</th>
                  <th className="px-4 py-3 font-semibold">Fecha de eliminación</th>
                </tr>
              </thead>
              <tbody>
                {items.map((m) => (
                  <tr key={m.id} className="border-b border-slate-100" data-testid={`eliminada-row-${m.id}`}>
                    <td className="px-5 py-3 font-semibold text-slate-800">{m.folio}</td>
                    <td className="px-4 py-3 text-slate-600">{m.cliente_nombre}</td>
                    <td className="px-4 py-3 text-slate-500">{ESTADO_LABEL[m.estado_solicitud] || m.estado_solicitud}</td>
                    <td className="px-4 py-3 text-slate-600">{m.deleted_by_nombre || "—"}</td>
                    <td className="px-4 py-3 text-slate-500">{m.deleted_at ? fechaHora(m.deleted_at) : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
